import React from 'react'
import AgreeNachAllButton from './fields/agreeNach/AgreeNachAllButton'
import AgreeEconomistAllButton from './fields/agreeEconomist/AgreeEconomistAllButton'
import AgreeDeputyDirectorSupplyAllButton from './fields/agreeDeputyDirectorSupply/AgreeDeputyDirectorSupplyAllButton'
import AgreeHeaderAllButton from './fields/agreeHeader/AgreeHeaderAllButton'

const SupplyBillItemAgreesAll = ({ supplyBillId, supplyBillItems }) => {
  return (
    <div className='supplyAgreesAll'>
        <p>Погодити все</p>
        <div className='supplyAgrees'>
            <AgreeNachAllButton
                supplyBillId={supplyBillId}
                supplyBillItems={supplyBillItems}
            />
            <AgreeEconomistAllButton 
                supplyBillId={supplyBillId}
                supplyBillItems={supplyBillItems}
            />
            <AgreeDeputyDirectorSupplyAllButton
                supplyBillId={supplyBillId}
                supplyBillItems={supplyBillItems}
            />
            <AgreeHeaderAllButton
                supplyBillId={supplyBillId}
                supplyBillItems={supplyBillItems}
            />
        </div>
    </div>
  )
}

export default SupplyBillItemAgreesAll